export enum NotificationBillingType {
  UNSET_TYPE = 'UNSET_TYPE', // Do not use, needed because of proto3 limitations
  SYSTEM = 'SYSTEM',
  COMMERCIAL = 'COMMERCIAL',
}
